export default __webpack_public_path__ + "static/media/sprites_27_9.cd98da0b.png";